/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */

/**
 * What does not add up in a logbook entry (FAFD-26). Travels as an int on the wire — never
renumber. Everything but FacilityFlow.Core.Modules.Fleet.Dtos.VehicleLogbookIssue.Edited and FacilityFlow.Core.Modules.Fleet.Dtos.VehicleLogbookIssue.OutsideWorkingTime needs attention.
 */
export type FacilityFlowCoreModulesFleetDtosVehicleLogbookIssue = typeof FacilityFlowCoreModulesFleetDtosVehicleLogbookIssue[keyof typeof FacilityFlowCoreModulesFleetDtosVehicleLogbookIssue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FacilityFlowCoreModulesFleetDtosVehicleLogbookIssue = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
  NUMBER_8: 8,
  NUMBER_9: 9,
  NUMBER_10: 10,
  NUMBER_11: 11,
  NUMBER_12: 12,
  NUMBER_13: 13,
} as const;
